module.exports = __webpack_public_path__ + "static/media/screen4.9d0a8e80.png";